/**
 * @file mutation-types
 * @author liuyanan06
 */

export const GET_URL_PARAM = 'getUrlParam';
// 音乐状态
// export const UPDATE_MUSIC_PLAYING_STATUS = 'updateMusicPlayingStatus';
// export const UPDATE_GYROSCOPE_STATUS = 'updateGyroscopeStatus';

// pano
export const SET_LINKS_CONTROL_STATUS = 'setLinksControlStatus';
export const SET_IS_PANO_READY = 'setIsPanoReady';

// // 设置全景点赞数
// export const SET_PANO_LIKED_INFO = 'setPanoLikeInfo';
// // 设置全景分享数
// export const SET_PANO_SHARE_INFO = 'setPanoShareInfo';
// // 设置页面全景信息数据
// export const SET_PANO_INFO = 'setPanoInfo';

// 设置剩余 缓存全景的数据
export const SET_PANO_LIST = 'setPanoList';

// 是否停止全景自动旋转
export const SET_IS_TOUCH = 'setIsTouch';
export const SET_PRE_TOUCH = 'setPreTouch';

// 留言详情面板控制状态
export const SET_MESSAGE_BOARD_SHOW_STATUS = 'setMessageBoardShowStatus';
export const SET_HEADER_STATUS = 'setHeaderStatus';
// export const SET_CONTROL_BOARD_SHOW_STATUS = 'setControlBoardShowStatus';
// export const SET_MESSAGE_SHOW_STATUS = 'setMessageShowStatus';

// 右上角菜单面板显示状态
export const SET_MENU_SHOW_STATUS = 'setMenuShowStatus';
// 是否是写留言状态
export const SET_WRITE_MESSAGE_SHOW_STATUS = 'setWriteMessageShowStatus';
// 清屏 全屏模式
export const SET_FULL_SCREEN_STATUS = 'setFullScreenStatus';

// marks && messageInfo
export const SET_MARK_LIST = 'setMarkList';
export const SET_MARK_LIKED_INFO = 'setMarkLikedInfo';
export const SET_LIKE_BY_ID = 'setLikeById';
export const SET_CURRENT_MARKER_INFOS = 'setCurrentMarkerInfos';
export const DELETE_MESSAGE_BY_ID = 'deleteMessageById';
export const DELETE_REPLY_BY_ID = 'deleteReplyById';
export const SET_REPLY_INFOS = 'setReplyInfos';
export const SET_REPLY_LIKED_INFOS = 'setReplyLikedInfos';
export const CLEAR_MARK_INFOS = 'clearMarkInfos';
export const ADD_NEW_SUBMITTED_REPLY = 'addNewSubmittedReply';
export const ADD_NEW_SUBMITTED_MARK = 'addNewSubmittedMark';
export const SET_LOGIN_INFO = 'setLoginInfo';
export const SET_RECOM_LIST = 'setRecomList';
export const SET_REPLY_LIKE_BY_ID = 'setRelyLikeById';
export const SET_REPLY_INFOS_HASNEXT = 'setReplyInfosHasnext';
export const SET_REPLY_INFOS_TOTAL = 'setReplyInfosTotal';

// 设置分享点击信息
export const SET_SHARE_CLIKED_INFO = 'setShareClickedInfo';

// 音乐以及反馈问题数据
export const MAKE_MUSIC_FEED_DATA = 'makeMusicFeedData';

// 设置当前tab 索引
export const SET_CUR_TAB_INDEX = 'setCurTabIndex';


// 设置留言总数
export const SET_MSG_COUNT_NUM = 'setMsgCountNum';

// 更改全部留言页数
export const SET_IS_LAST_PAGE = 'setIsLastPage';

// 更改全部留言页数
export const SET_ALL_MESSAGE_LIST = 'setAllMessageList';
// 删除全部留言下的 留言
export const DELETE_ALL_MESSAGE_BY_ID = 'deleteAllMessageById';
// 更改全部留言页数
export const SET_ALL_MESSAGW_SHOW_STATUS = 'setAllMessageShowStatus';
// 更改全部留言有回复的留言点击后的 marker rank等级
export const SET_CHOOSEN_MARKER_RANK = 'setChoosenMarkerRank';

// 设置当前全景数据信息(简介、分享、点赞数)
export const SET_CUR_PANO_INFO = 'setCurPanoInfo';
// 当前pid
export const SET_CURRENT_PID = 'setCurrentPid';
// 设置主题页相册数据
export const SET_ALBUM_DATA = 'setAlbumData';
// 设置主题页相册点击时索引
export const SET_ALBUM_ACTIVE_INDEX = 'setAlbumActiveIndex';
// 设置顶部 tab 数据
export const SET_TAB_LIST = 'setTabList';
// 更改当前 tab 下的 list的 index
export const SET_CUR_TAB_LIST_INDEX = 'setCurTabListIndex';
// 更改当前tab下 list 的 最大index，为了上一个的时候不发统计时长
export const SET_CUR_TAB_LIST_MAX_INDEX = 'setCurTabListMaxIndex';
// 更改当前tab curTabIndex下的 panoList
export const SET_CUR_TAB_PANO_LIST = 'setCurTabPanoList';
// 更改推荐下的 panoList
export const SET_DEFAULT_PANO_LIST = 'setDefaultPanoList';

export const SET_RENDER_LIST = 'setRenderList';
// 设置当前渲染列表
export const SET_CUR_RENDER_LIST = 'setRenderList';

// 删除的次数
export const SET_DELETE_NUM = 'setDeleteNum';
// 设置 swiper acNum
export const SET_SWIPER_AC_NUM = 'setSwiperListAcNum';
// 设置 cityID
export const SET_CITY_ID = 'setCityId';

export const SET_UDC = 'setUdc';

// 客户端信息里网络参数
export const SET_BAIDUMAP_NET = 'setBaiduMapNet';
// 设置提示条数据
export const SET_ATTENTION_INFO = 'setAttentionInfo';
// 设置提示条展示状态
export const SET_NOTICE_TIP_STATUS = 'setNoticeTipStatus';
// 8期
// 排行榜单数据
export const SET_RANK_DATA = 'setRankData';
// 设置当前榜单索引
export const SET_CUR_RANK_INDEX = 'setCurRankIndex';
export const SET_HOT_LIST_STATUS = 'setHotListStatus';
export const SET_ALL_RANK = 'setAllRank';
export const SET_DEFAULT_ALL_RANK = 'setDefaultAllRank';
export const SET_ALL_RANK_AC_INDEX = 'setAllRankAcIndex';
export const SET_CHOOSE_RANK_INDEX = 'setChooseRankIndex';
export const SET_RANK_SHOW_FR = 'setRankShowFr';
export const SET_LIKE_NUM = 'setLikeNum';
export const SET_LIKE_NUM_BY_ID = 'setLikeNumById';

export const SET_PANO_AUTHOR_INFO = 'setPanoAuthorInfo';

// 设置全景流是否激活
export const SET_PANO_ACTIVATED = 'setPanoAcyivated';
